
export enum PagamentoStatus {
    PAGO = "Pago",
    PENDENTE = "Pendente",
    REJEITADO = "Rejeitado",
}